import { BCMSStateManagerCRUD } from "@bcm-dev/bcms-vite";
import LoginPage, { getDefaultPageData } from "components/pages/LoginPage";

/**
 * @name CaptureSoftTokensLogInLoginPage
 * @returns {React.Component}
 * @description A capture component in the capture group "Soft Tokens - Logging In".
 */
export default function CaptureSoftTokensLogInUserIDEntered(props) {
    const data = BCMSStateManagerCRUD.init(getDefaultPageData())
    .update([ "userID" ], "DemoUser")
    .update([ "password" ], "")
    .submit();

    return <LoginPage data={ data } />
}